import { NgModule } from '@angular/core';
import { CalendarRoutingModule } from './calendar-routing.module';
import { CalendarComponent } from './calendar.component';
import { CommonModule, DatePipe } from '@angular/common';
import { NotificationsModule } from '@app/+notifications/notifications.module';


import { FormsModule } from '@angular/forms';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ToolbarModule} from 'primeng/toolbar';

import {ButtonModule} from 'primeng/button';
import {RadioButtonModule} from 'primeng/radiobutton';
import {PopoverModule } from 'primeng/popover';
import { InputNumberModule } from 'primeng/inputnumber';
import {CalendarStateModule} from '@app/+calendar/calendar-state.module'
import { TreeTableModule } from 'primeng/treetable';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { SomaTaskViewDialogComponent } from '@app/dialogs/taskViewDialogs/soma-task-view-dialog/soma-task-view-dialog.component';
import { SupplierTaskDialogComponent } from '@app/dialogs/taskViewDialogs/supplier-task-dialog/supplier-task-dialog.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MatIconModule } from '@angular/material/icon';
import { FullCalendarModule } from '@fullcalendar/angular';
import { MediatipsModule } from '@app/+mediatips/mediatips.module';


@NgModule({
    imports: [
        CalendarRoutingModule, CommonModule, NotificationsModule,  FullCalendarModule, FormsModule, ProgressSpinnerModule,
        DatePipe, SomaTaskViewDialogComponent, SupplierTaskDialogComponent,
        SomaTaskViewDialogComponent, SupplierTaskDialogComponent,
        ToolbarModule,  RadioButtonModule, CalendarStateModule, PopoverModule , TreeTableModule, CheckboxModule, SelectModule,
        MultiSelectModule, TableModule, NgxChartsModule, InputNumberModule, ButtonModule, MatIconModule,
        MediatipsModule
    ],
    exports: [CalendarComponent,  SupplierTaskDialogComponent],
    declarations: [
        CalendarComponent,
    ],
    providers: []
})
export class CalendarModule { }
